var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        scrollable: "",
        "max-height": "auto",
        "max-width":
          _vm.$vuetify.breakpoint.name == "xs" ||
          _vm.$vuetify.breakpoint.name == "sm"
            ? "90%"
            : "55%",
        persistent: "",
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        {
          staticClass: "mx-auto elevation-0 overflow-y-auto",
          attrs: {
            outlined: "",
            height: "85vh",
            prominent: "",
            loading: _vm.loading,
          },
        },
        [
          _c(
            "v-card-title",
            { staticClass: "ma-0 pa-0" },
            [
              _c(
                "v-app-bar",
                {
                  staticClass: "mb-4 elevation-1",
                  attrs: { dense: "", height: "45" },
                },
                [
                  _c("v-toolbar-title", { staticClass: "subtitle-1" }, [
                    _vm._v(" Filtros "),
                  ]),
                  _c("v-spacer"),
                  _c(
                    "v-tooltip",
                    {
                      attrs: { bottom: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function ({ on, attrs }) {
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  _vm._b(
                                    {
                                      attrs: { icon: "" },
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.clearFilter()
                                        },
                                      },
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "primary lighten-2" } },
                                    [_vm._v("mdi-filter-remove-outline")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [_c("span", [_vm._v("Limpar Filtro")])]
                  ),
                  _c(
                    "v-tooltip",
                    {
                      attrs: { bottom: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function ({ on, attrs }) {
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  _vm._b(
                                    {
                                      attrs: { icon: "" },
                                      nativeOn: {
                                        click: function ($event) {
                                          _vm.dialog = false
                                        },
                                      },
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "red lighten-2" } },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [_c("span", [_vm._v("Fechar")])]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-text",
            { staticClass: "pt-2" },
            [
              _c(
                "v-container",
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6" } },
                        [
                          _c("sys-select-brand", {
                            attrs: {
                              model: _vm.brand_id,
                              label: "Marca",
                              "auto-complete": "",
                              clearable: "",
                            },
                            on: {
                              "update:model": function ($event) {
                                _vm.brand_id = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6" } },
                        [
                          _c("sys-select-campus", {
                            attrs: {
                              model: _vm.campus_id,
                              label: "Campus*",
                              "auto-complete": "",
                              "brand-id": _vm.brand_id,
                            },
                            on: {
                              "update:model": function ($event) {
                                _vm.campus_id = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6" } },
                        [
                          _c("sys-select-shift", {
                            attrs: {
                              model: _vm.shift_id,
                              label: "Turno",
                              clearable: "",
                            },
                            on: {
                              "update:model": function ($event) {
                                _vm.shift_id = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6" } },
                        [
                          _c("sys-select-day-of-week", {
                            attrs: {
                              model: _vm.day_of_week_id,
                              label: "Dia da semana",
                              clearable: "",
                            },
                            on: {
                              "update:model": function ($event) {
                                _vm.day_of_week_id = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "12" } },
                        [
                          _c("sys-select-block", {
                            attrs: {
                              model: _vm.blocks,
                              label: "Bloco",
                              multiple: "",
                              selectAll: "",
                              "campus-id": _vm.campus_id,
                              disabled: _vm.campus_id == null,
                            },
                            on: {
                              "update:model": function ($event) {
                                _vm.blocks = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6" } },
                        [
                          _c("sys-select-ambience-type", {
                            attrs: {
                              model: _vm.types,
                              label: "Tipo de Ambiente",
                              multiple: "",
                              selectAll: "",
                              "campus-id": _vm.campus_id,
                              disabled: _vm.campus_id == null,
                            },
                            on: {
                              "update:model": function ($event) {
                                _vm.types = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6" } },
                        [
                          _c("sys-select-work-load-type", {
                            attrs: {
                              model: _vm.workLoads,
                              label: "Tipo de CH",
                              multiple: "",
                              selectAll: "",
                            },
                            on: {
                              "update:model": function ($event) {
                                _vm.workLoads = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c("v-col", { attrs: { cols: "12", sm: "6" } }),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6" } },
                        [
                          _c("v-range-slider", {
                            staticClass: "align-center",
                            attrs: {
                              min: 0,
                              max: 500,
                              hint: "Capacidade do Ambiente",
                              "persistent-hint": "",
                              "thumb-label": "always",
                              dense: "",
                            },
                            model: {
                              value: _vm.capacity,
                              callback: function ($$v) {
                                _vm.capacity = $$v
                              },
                              expression: "capacity",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6" } },
                        [
                          _c("v-range-slider", {
                            staticClass: "align-center",
                            attrs: {
                              min: 0,
                              max: 1000,
                              hint: "Alunos",
                              "persistent-hint": "",
                              "thumb-label": "always",
                              dense: "",
                            },
                            model: {
                              value: _vm.students,
                              callback: function ($$v) {
                                _vm.students = $$v
                              },
                              expression: "students",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6" } },
                        [
                          _c("v-range-slider", {
                            staticClass: "align-center",
                            attrs: {
                              min: -1000,
                              max: 1000,
                              hint: "Saldo",
                              "persistent-hint": "",
                              "thumb-label": "always",
                              dense: "",
                            },
                            model: {
                              value: _vm.balance,
                              callback: function ($$v) {
                                _vm.balance = $$v
                              },
                              expression: "balance",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6" } },
                        [
                          _c("v-switch", {
                            staticClass: "ml-3",
                            attrs: {
                              inset: "",
                              label: "Apenas Turmas Principais",
                            },
                            model: {
                              value: _vm.onlyMain,
                              callback: function ($$v) {
                                _vm.onlyMain = $$v
                              },
                              expression: "onlyMain",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6" } },
                        [
                          _c("v-switch", {
                            staticClass: "ml-3",
                            attrs: {
                              inset: "",
                              label: "Apenas Salas Disponíveis (0%)",
                            },
                            model: {
                              value: _vm.onlyEmpty,
                              callback: function ($$v) {
                                _vm.onlyEmpty = $$v
                              },
                              expression: "onlyEmpty",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "success", disabled: _vm.disableButton },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      $event.stopPropagation()
                      return _vm.filter()
                    },
                  },
                },
                [
                  _vm._v(" Filtrar "),
                  _c("v-icon", { attrs: { right: "", dark: "" } }, [
                    _vm._v("mdi-filter-menu-outline"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }